const translations = {
  title: 'Formularios',
  'menu.triggers': 'Automatizaciones',
  'menu.integrations': 'Integraciones',
  name: 'Nombre',
  checklist: 'Cuestionario',
  replies: 'Respuestas',
  access: 'Acceso',
  cardsView: 'Vista de tarjetas (próximamente)',
  requiredAnswersMissing: 'Faltan respuestas obligatorias',
  requiredAnswersMissingMessage: 'Verifique las preguntas con las etiquetas rojas.',
  successTitle: '¡Formulario respondido con éxito!',
  successBody: 'Gracias por sus respuestas',
  sentSuccessfully: 'Enviado con éxito.',
  alreadyRepliedTitle: 'Formulario ya respondido',
  alreadyRepliedDescription: 'No puede responder este formulario porque ya fue respondido el {{date}}',
  bulkRegistration: 'Registro masivo',
  sendHistory: 'Historial de envíos',
  removeConfirm: '¿Está seguro de que desea eliminar?',
  removeError: '¡Ocurrió un error al eliminar!',
  exportToExcel: 'Exportar a Excel',
  resume: 'Resumen',
  share: 'Compartir',
  sendHistoryMenu: 'Historial de Envíos',
  logs: 'Registros',
  edit: 'Editar',
  remove: 'Eliminar',
  sendDate: 'Fecha de envío',
  invites: 'Invitaciones',
  replied: 'Respondidos',
  resend: 'Reenviar'
}

export default translations
